export default "/img/SE.663a1c4476083cbb4ef3c50256f5cf33.png";